import { useExperimentFlags } from '@hungryroot/experiments';
import {
  ACCOUNT_PREFERENCES_NEVERS_ROUTE,
  FOOD_PROFILE_INGREDIENT_DISLIKES_ROUTE,
  FOOD_PROFILE_NEVERS_ROUTE,
} from '@hungryroot/routes';

/**
 * Link target for Food Profile nevers / Ingredient Dislikes from PDP OSN
 * override alerts.
 *
 * Exp 195: v1 → tag Nevers; v12 → Ingredient Dislikes; control / v10 → legacy
 * Account Preferences deep link. While assignment is loading, default to
 * legacy.
 */
export function useFoodProfileNeversUrl(): string {
  const exp195 = useExperimentFlags(195);

  if (exp195.isLoading) {
    return ACCOUNT_PREFERENCES_NEVERS_ROUTE;
  }

  if (exp195.destinationFoodProfileExp195.isVariant12) {
    return FOOD_PROFILE_INGREDIENT_DISLIKES_ROUTE;
  }

  return exp195.destinationFoodProfileExp195.isVariant1
    ? FOOD_PROFILE_NEVERS_ROUTE
    : ACCOUNT_PREFERENCES_NEVERS_ROUTE;
}
